export default __webpack_public_path__ + "static/media/Video-Quiz.be626516.gif";